const getCurrentLectureTitle = (pages, currentPageId) =>
  pages?.find((page) => Number(page.id) === Number(currentPageId))
    ?.lectureTitle;

const getCurrentLectureIsFree = (pages, currentPageId) =>
  pages?.find((page) => Number(page.id) === Number(currentPageId))?.isFree;

export { getCurrentLectureTitle, getCurrentLectureIsFree };
